import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import classnames from 'classnames';
import Bullet from './bullet';

const Name = styled.div`
  color: #333;
  font-weight: bold;
  font-size: 29px;
  width: 100%;
  line-height: 68px;
  
  &.large {
    font-size: 30px;
  }
`;

const Explain = styled.div`
  color: #686868;
  font-size: 29px;
  line-height: 40px;
  width: 100%;
  text-align: justify;
  padding: 0;
  padding-left: 42px;
`;

class Definition extends Component {
  render() {
    const { large, name } = this.props;
    return (
      <div style={{ marginTop: '15px' }}>
        <Name className={classnames({ large })}><Bullet />{name}</Name>
        {this.props.explain.map((e, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Explain key={i}>{e}</Explain>
        ))}
      </div>
    );
  }
}

Definition.propTypes = {
  name: PropTypes.string.isRequired,
  explain: PropTypes.arrayOf(PropTypes.string).isRequired,
  large: PropTypes.bool,
};
Definition.defaultProps = {
  large: false
};

export default Definition;



// WEBPACK FOOTER //
// ./src/components/definition.jsx